import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
export var NativeSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NativeSelect, _React$Component);

  function NativeSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NativeSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NativeSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "htmlSelectRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "setOptionState", function (index, selected) {
      var htmlSelect = _this.htmlSelectRef.current;
      htmlSelect.options[index].selected = selected;
      htmlSelect.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOptionState", function (index) {
      var htmlSelect = _this.htmlSelectRef.current;

      _this.setOptionState(index, !htmlSelect.options[index].selected);
    });

    _defineProperty(_assertThisInitialized(_this), "click", function () {
      _this.htmlSelectRef.current.click();
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(e, _this.getValue(e.currentTarget));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getValue", function (select) {
      if (!_this.props.multiple) {
        return _this.props.options[select.selectedIndex].value;
      }

      var value = [];

      for (var i = 0; i < select.options.length; i++) {
        var isSelected = select.options[i].selected;

        if (isSelected) {
          value.push(_this.props.options[i].value);
        }
      }

      return value;
    });

    return _this;
  }

  _createClass(NativeSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          options = _this$props.options,
          value = _this$props.value,
          passedProps = _objectWithoutProperties(_this$props, ["options", "value"]);

      return React.createElement("select", _extends({}, passedProps, {
        ref: this.htmlSelectRef,
        onChange: this.handleChange,
        tabIndex: -1 // tslint:disable-next-line: no-any
        ,
        value: value || undefined
      }), this.props.options.map(function (option, index) {
        return React.createElement("option", {
          key: index,
          value: option.value
        }, option.label);
      }));
    }
  }]);

  return NativeSelect;
}(React.Component);